export const SEASON_TYPES = [
  "ramadan", "eid_fitr", "eid_adha", "national_day", "festive",
  "summer", "school_holiday", "custom",
];

export const isBusinessDate = (value) => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value || "")) return false;
  const date = new Date(`${value}T00:00:00Z`);
  return !Number.isNaN(date.getTime()) && date.toISOString().slice(0, 10) === value;
};

export const validateSeason = (season) => {
  if (!season.name?.trim()) return "Enter a season name.";
  if (!SEASON_TYPES.includes(season.type)) return "Select a season type.";
  if (!isBusinessDate(season.start) || !isBusinessDate(season.end)) {
    return "Enter valid business dates.";
  }
  if (season.start > season.end) return "End must be on or after start.";
  if (Number(season.year) !== Number(season.start.slice(0, 4))) {
    return "Season year must match the start business date.";
  }
  return "";
};

export const previousSeason = (seasons, season) => {
  const matches = seasons.filter((entry) =>
    String(entry.brandId) === String(season.brandId) &&
    entry.type === season.type && Number(entry.year) === Number(season.year) - 1 &&
    (!['custom', 'school_holiday'].includes(season.type) ||
      (season.seriesId && entry.seriesId === season.seriesId))
  );
  return matches.length === 1 ? matches[0] : null;
};

const midnightInZone = (businessDate, timeZone) => {
  const target = Date.parse(`${businessDate}T00:00:00Z`);
  const formatter = new Intl.DateTimeFormat("en-GB", {
    timeZone, year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit", second: "2-digit", hourCycle: "h23",
  });
  let timestamp = target;
  for (let attempt = 0; attempt < 3; attempt += 1) {
    const parts = Object.fromEntries(formatter.formatToParts(timestamp).map(
      ({ type, value }) => [type, value]
    ));
    const represented = Date.UTC(Number(parts.year), Number(parts.month) - 1,
      Number(parts.day), Number(parts.hour), Number(parts.minute), Number(parts.second));
    timestamp += target - represented;
  }
  return Math.floor(timestamp / 1000);
};

export const seasonRange = (season, timeZone = "Asia/Qatar") => {
  const error = validateSeason(season);
  if (error) throw new Error(error);
  const followingDay = new Date(`${season.end}T00:00:00Z`);
  followingDay.setUTCDate(followingDay.getUTCDate() + 1);
  const start = midnightInZone(season.start, timeZone);
  const endExclusive = midnightInZone(followingDay.toISOString().slice(0, 10), timeZone);
  const [year, month, day] = season.start.split("-").map(Number);
  const [endYear, endMonth, endDay] = season.end.split("-").map(Number);
  return {
    start: { long: new Date(year, month - 1, day), short: start },
    end: { long: new Date(endYear, endMonth - 1, endDay, 23, 59, 59), short: endExclusive - 1 },
    endExclusive,
    businessDates: { start: season.start, end: season.end, timeZone },
  };
};